<template>
    <div>
        <el-card>
            <div slot="header" class="clearfix" style="text-align:center;">
                <a style="text-decoration:none;color:#337ab7;cursor:pointer; float: left; line-height: 36px;" @click="returnBack">返回</a>
                <span style="line-height: 36px;">取货流程配置</span>
            </div>
            <div class="card-body" style="text-align:left;">
                <div class="item-list">

                  <p>
                      <span class="span_1" >取货流程：</span>
                      <el-input v-model="flow" style="width:200px;"></el-input>
                  </p>
                  <p>
                      <span class="span_1">价格(分)：</span>
                      <el-input v-model="price" style="width:200px;"></el-input>
                  </p>
                  <p v-if="flow!=6">
                      <span class="span_1">是否获取用户信息：</span>
                      <el-switch
                            v-model="bGetUserInfo"
                            active-color="#13ce66"
                            inactive-color="#dddddd"
                            active-value="1"
                            inactive-value="0"
                            @change="changeGetUserInfo()">
                            </el-switch>

                      <span class="span_1" style="width:500px;margin-left:50px;">如果要加精准粉丝或获得用户头像、昵称等，请打开此选项。有且仅有一次授权过程</span>
                  </p>

                  <p>
                      <span class="span_1">是否重复领取：</span>
                    <el-switch
                          v-model="bExtendInfo"
                          active-color="#13ce66"
                          inactive-color="#dddddd"
                          active-value="1"
                          inactive-value="0"
                          @change="changeRepeat()">
                          </el-switch>
                  </p>


                  <p v-if="day!=0">
                      <span class="span_1" >每x天可取：</span>
                      <el-input v-model="day" style="width:200px"></el-input>
                  </p>
                  <p v-if="day!=0">
                      <span class="span_1">每次可取N包：</span>
                      <el-input v-model="num" style="width:200px"></el-input>
                  </p>
                  <p v-if="day!=0 && num>1">
                      <span class="span_1" >每次间隔x分钟：</span>
                      <el-input v-model="interval" style="width:200px"></el-input>
                  </p>


                  <p>
                      <span class="span_1">多个广告时是否限制每天一个：</span>
                    <el-switch
                          v-model="bLimitDay"
                          active-color="#13ce66"
                          inactive-color="#dddddd"
                          active-value="1"
                          inactive-value="0"
                          >
                          </el-switch>
                  </p>

                  <p >
                      <span class="span_1" >取货位置限制：</span>
                      <el-input v-model="posLimit" style="width:200px"></el-input>
                      <span class="span_1" style="width:500px;margin-left:50px;">0表示不限制，单位是米</span>
                  </p>

                  <p >
                      <span class="span_1" >微信APPID（位置）：</span>
                      <el-input v-model="appid" style="width:200px"></el-input>
                      <span class="span_1" style="width:500px;margin-left:50px;">这里配置会影响到获取用户位置等功能，请在咨询开发人员后再进行配置（留空即可，需同时配置JS安全域名，域名验证等）</span>
                  </p>

                  <p >
                      <span class="span_1" >微信APPID（支付）：</span>
                      <el-input v-model="payappid" style="width:200px"></el-input>
                      <span class="span_1" style="width:500px;margin-left:50px;">这里配置会影响到支付功能，请在咨询开发人员后再进行配置（留空即可，需同时配置JS安全域名，域名验证等）</span>
                  </p>


                  <p v-if="flow>=22 && flow<30 " >
                      <span class="span_1">闪屏画面：</span>
                      <el-input v-model="splashImg" style="width:60%"></el-input>
                  </p>
                  <p v-if="flow>=22 && flow<30">
                      <span class="span_1">闪屏计时(s)：</span>
                      <el-input v-model="splashTime" style="width:200px"></el-input>
                  </p>
                  <p v-if="flow>=22 && flow<30">
                      <span class="span_1">关注二维码背景：</span>
                      <el-input v-model="mainImg" style="width:60%"></el-input>
                  </p>

                  <p v-if="flow==23">
                      <span class="span_1">取货等待图：</span>
                      <el-input v-model="qzImg" style="width:60%"></el-input>
                  </p>


                  <p>
                      <span class="span_1">取货完成跳转URL：</span>
                      <el-input v-model="jumpUrl" style="width:60%"></el-input>
                  </p>


                </div>


                <div style="text-align: center">
                    <el-button class="item-right" type="info" :loading="btnLogin" @click="btnSave()">保存</el-button>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
  import $ajax from '../../https/config'
  import adSelectDevice from '@/page/adMgr/adSelectDevice'
  import {isNull} from '../../js/tool'

  export default {
    data () {
      return {
        flow:10,
        price:100,
        bExtendInfo:false,
        day:0,
        num:0,
        interval:0,
        splashImg:"",
        splashTime:"",
        mainImg:"",
        bGetUserInfo:false,
        jumpUrl:"",
        qzImg:"",
        btnLogin:false,
        posLimit:0,
        appid:"",
        payappid:"",
        bLimitDay:false
      }
    },
    created: function () {
      this.getUserConfig()
    },
    methods: {
      changeRepeat () {
        if (this.day==0){
          this.day = 1
          this.num = 1
          this.interval = 0
          this.bExtendInfo = true
        }else{
          this.day = 0
          this.num = 0
          this.interval = 0
          this.bExtendInfo = false
        }
      },
      getUserConfig: function () {
        var url = '/userChargeConfig/getUserConfig'
        var _this = this
        $ajax.get(url, null, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            var resData = []
            if (res.resultData ) {
              _this.flow = res.resultData.status
              _this.price = res.resultData.charge
              _this.bGetUserInfo = res.resultData.bGetUserInfo


              //res.resultData.extendInfo = ''
              if (isNull(res.resultData.extendInfo) || res.resultData.extendInfo=="0") {
                //_this.bExtendInfo = false
                _this.day=0
              }else{

                //_this.bExtendInfo = true
                //设置一些东西
                if (res.resultData.extendInfo.indexOf("{")>-1){
                  var extObj = JSON.parse(res.resultData.extendInfo);

                  //alert("1");

                  if (extObj!=null){
                    _this.jumpUrl = extObj.jumpUrl

                    _this.day = isNull(extObj.day)?0:extObj.day
                    _this.num = isNull(extObj.num)?0:extObj.num
                    _this.interval = isNull(extObj.interval)?0:extObj.interval
                    _this.posLimit = isNull(extObj.posLimit)?0:extObj.posLimit
                    _this.appid = isNull(extObj.appid)?"":extObj.appid
                    _this.bLimitDay = isNull(extObj.bLimitDay)?false:extObj.bLimitDay
                    _this.payappid = isNull(extObj.payappid)?"":extObj.payappid

                    if (_this.flow>=22&&_this.flow<=30){
                      _this.splashImg = extObj.splashImg
                      _this.splashTime = extObj.splashTime
                      _this.mainImg = extObj.mainImg
                    }
                    if (_this.flow==23){
                      _this.splashImg = extObj.splashImg
                      _this.splashTime = extObj.splashTime
                      _this.mainImg = extObj.mainImg
                      _this.qzImg = extObj.qzImg
                    }
                  }
                }else{
                  //这里不补充了
                }
              }
            } else {
            }

          }
        }, function () {})
      },
      changeSwicth: function () {
        //this.bExtendInfo = !this.bExtendInfo
      },
      changeGetUserInfo: function () {
        //this.bGetUserInfo = !this.bGetUserInfo
      },
      btnOpenSelectPop: function () {
        this.selectPopShow = true
      },
      closeSelectDevicePop: function (val) {
        this.selectPopShow = false
        this.selectedDevices = val
      },
      handleClose: function (deviceCode) {
        this.selectedDevices.splice(this.selectedDevices.indexOf(deviceCode), 1)
      },
      btnSave: function () {
        var _this = this
        var extendInfo="";
        var extendInfoObj = {};
        if (_this.day==0){
          extendInfoObj.day=0;
          extendInfoObj.num=0;
          extendInfoObj.interval=0;
        }else{
          _this.bExtendInfo = true;
          extendInfoObj.day=parseInt(_this.day);
          extendInfoObj.num=parseInt(_this.num);

          if (extendInfoObj.num>1){
              extendInfoObj.interval=parseInt(_this.interval);
          }else{
            extendInfoObj.interval=0;
          }

        }

        if (_this.flow>=22&&_this.flow<=30){
          extendInfoObj.splashImg = _this.splashImg;
          extendInfoObj.splashTime = _this.splashTime;
          extendInfoObj.mainImg = _this.mainImg;
        }
        if (_this.flow==23){
          extendInfoObj.splashImg = _this.splashImg;
          extendInfoObj.splashTime = _this.splashTime;
          extendInfoObj.mainImg = _this.mainImg;
          extendInfoObj.qzImg = _this.qzImg;
        }

        extendInfoObj.posLimit = parseInt(_this.posLimit);
        extendInfoObj.jumpUrl = _this.jumpUrl;
        extendInfoObj.bLimitDay = _this.bLimitDay;

        if (!isNull(_this.appid)){
          extendInfoObj.appid=_this.appid;
        }

        if (!isNull(_this.payappid)){
          extendInfoObj.payappid=_this.payappid;
        }

        var params = {
          status: _this.flow,
          charge: _this.price,
          bGetUserInfo: _this.bGetUserInfo,
          point:100,
          extendInfo:JSON.stringify(extendInfoObj)
        }
        $ajax.post('/userChargeConfig/updateGlobalConfig', params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            _this.$message({
              type: 'success',
              message: '保存全局配置成功!'
            })
            setTimeout(function () {
              _this.btnLogin = false
              //_this.returnBack()
              this.$router.go(0)
            }, 1000)
          } else {
            _this.$message({
              type: 'error',
              message: '保存全局配置失败!' + res.errorMessage
            })
            _this.btnLogin = false
          }
        })
      },
      returnBack () {
        this.$router.back(-1)
      }
    },
    components: {
      'ad-select-device': adSelectDevice
    }
  }
</script>
<style lang="scss">
    .card-body .item-list:nth-child(n+2) {
        margin-top: 20px;
    }
    .span_1{
            display: inline-block;
            width: 250px;

          }

    .item-list {
        display: inline-block;
        width: 100%;

        .item-left, .item-right {
            float: left;
            text-align: left;

        }

        .item-left {
             margin-right: 30px;
            span {
                vertical-align:sub;
                vertical-align:-webkit-baseline-middle;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/globalConfig/flowConfig.vue